// extracted by mini-css-extract-plugin
export default {"wrapper":"PlantList_wrapper__zDEh2","notFound":"PlantList_notFound__c+-af"};